import { render, staticRenderFns } from "./MobileSettings.vue?vue&type=template&id=73d12a1d&scoped=true"
import script from "./MobileSettings.vue?vue&type=script&lang=js"
export * from "./MobileSettings.vue?vue&type=script&lang=js"
import style0 from "./MobileSettings.vue?vue&type=style&index=0&id=73d12a1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d12a1d",
  null
  
)

export default component.exports